import { orchestrator } from 'satcheljs';
import setDomainState from '../mutators/setDomainState';
import setIsValidatingDomain from '../mutators/setIsValidatingDomain';
import { fetchAndValidateDomain } from '../actions/fetchAndValidateDomain';
import { fetchAndValidateDomain as fetchAndValidateDomainService } from '../services/fetchAndValidateDomain';

export default orchestrator(fetchAndValidateDomain, async function fetchAndValidateDomain() {
    setIsValidatingDomain(true);
    let response = await fetchAndValidateDomainService();
    setDomainState(response);
    setIsValidatingDomain(false);
});
